module.exports = __webpack_public_path__ + "static/media/symbol_new_doc.2985a9b3.svg";